import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-cotacao-seguro',
  templateUrl: './consulta-cotacao-seguro.component.html',
  styleUrls: ['./consulta-cotacao-seguro.component.scss']
})
export class ConsultaCotacaoSeguroComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {

    if(this.consulta) {
      this.consulta.dataUltimaAtualizacao = this.consulta.dataUltimaAtualizacao || this.consulta.dtUltimaAtualizacao || null;
    }

  }

}
